(function() {
  'use strict';

  function SlotController($scope, $translate, Security) {
    var ctrl = this;

    // this may be also used for the details view, move it if necessary
    ctrl.actionButtons = [
      // {
      //   label: $translate.instant('Edit'),
      //   icon: 'icon-edit',
      //   routerLink: ['/event-types', $scope.item.doc._id, 'edit'],
      //   showCondition: function() {
      //     if ($scope.item.doc.state !== 'draft') {
      //       return false;
      //     }

      //     return Security.hasPermission.bind(this, 'eventTypes.edit');
      //   },
      //   klass: 'text-info'
      // },
      // {
      //   label: $translate.instant('View'),
      //   icon: 'icon-view',
      //   routerLink: ['/event-types', $scope.item.doc._id, 'edit'],
      //   showCondition: function() {
      //     if ($scope.item.doc.state === 'draft') {
      //       return false;
      //     }

      //     return Security.hasPermission.bind(this, 'eventTypes.edit');
      //   },
      //   klass: 'text-info'
      // },
      {
        label: $translate.instant('Preview'),
        icon: 'icon-edit',
        // Use Router for Angular router navigation
        route: ['/event-types/preview', $scope.item.doc._id],
        showCondition: Security.hasPermission.bind(this, 'eventTypes.view'),
        klass: 'text-info'
      }
    ];

    ctrl.secondaryActionButtons = [
    ];

    ctrl.headVersion = _.last($scope.item.linkedVersions);

    if (ctrl.headVersion.state === 'published') {
      ctrl.headLog = _.find(ctrl.headVersion.auditLog, function(item) {
        return ['event_type_publish', 'published'].includes(item.action);
      });
    } else if (ctrl.headVersion.state === 'archived') {
      ctrl.headLog = _.find(ctrl.headVersion.auditLog, function(item) {
        return item.action.includes('archive');
      });
    } else {
      ctrl.headLog = _.last(ctrl.headVersion.auditLog);
    }
    var published = _.find($scope.item.linkedVersions, { state: 'published' });
    if (published && published !== ctrl.headVersion) {
      ctrl.published = published;
      ctrl.publishedLog = _.find(published.auditLog, function(item) {
        return ['event_type_publish', 'published'].includes(item.action);
      });
    }
  }

  SlotController.$inject = ['$scope', '$translate', 'SecurityService'];

  function SlotDirective() {
    return {
      scope: {
        item: '=',
        options: '='
      },
      restrict: 'AE',
      templateUrl: 'app/components/event-types/event-type.slot.html',
      controller: SlotController,
      controllerAs: 'ctrl'
    };
  }

  angular.module('component.goals')
    .directive('eventTypeSlot', SlotDirective)
    .controller('eventTypeSlotController', SlotController);
})();
